



























import {Component, ModelSync, Prop, Vue} from 'vue-property-decorator'
import {handleClipboard} from "@/util/clipboard"
import _ from 'lodash'

@Component({})
export default class IdColumn extends Vue {

  @Prop({default: 'id'})
  prop!: string

  @ModelSync('id', 'input')
  readonly idSync!: number

  @Prop({default: undefined})
  search?: (() => {})

  @Prop({default: undefined})
  label?: string

  private getHeader() {
    return this.label ?? this.$translate('id')
  }

  private copy = handleClipboard

  private getPropValue(row: {}) {
    return _.get(row, this.prop)
  }
}
